"use strict";

var _themeSections = require("@shopify/theme-sections");

require("../sections/featured-blog-posts");

require("../sections/large-video-banner");
/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */


function freeReadsCookieCheck() {
  if (window.sessionStorage.getItem('mb_submit_attempt') === null) {
    return;
  }

  if (window.sessionStorage.getItem('mb_free_reads') === null) {
    return;
  }

  var redirectLocation = window.sessionStorage.getItem('mb_free_reads');
  window.sessionStorage.removeItem('mb_free_reads');
  window.sessionStorage.removeItem('mb_submit_attempt');
  window.location = redirectLocation;
}

document.addEventListener('DOMContentLoaded', function () {
  (0, _themeSections.load)('*');
  freeReadsCookieCheck();
});